import {useDispatch, useSelector} from "react-redux";
import {SORT_LIST_BEAUTY_EMPTIES} from "../../utils/sort-list";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffect} from "react";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";
import {BeautyEmptiesList} from "./beauty-empties-list";
import {BeautyEmptiesFilter} from "./beauty-empties-filter";
import {setBeautyEmptiesSelectedRowKeys} from "../../reducers/beauty-empties.reducer";

const BeautyEmptiesPage = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_BEAUTY_EMPTIES?.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        filter,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey,
        filterByStatus: filter['status'] ?? []
    }
    const {
        data: response,
        fetching: getBeautyEmptiesList,
        isLoading
    } = useFetch(API.BEAUTY_EMPTIES_LIST, queryParams, {isWithTotalData: true})

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setBeautyEmptiesSelectedRowKeys([]))
        }
    }, [])

    useEffectAfterMount(() => {
        getBeautyEmptiesList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, filter, reload])

    return (
        <div className={"col px-10"}>
            <BeautyEmptiesFilter/>
            <BeautyEmptiesList dataSource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default BeautyEmptiesPage
